import {
  LIST_LOCATION_REQUEST,
  LIST_LOCATION_SUCCESS,
  LIST_LOCATION_FAIL,
  LIST_LOCATION_WITH_CLIENTID_REQUEST,
  LIST_LOCATION_WITH_CLIENTID_SUCCESS,
  LIST_LOCATION_WITH_CLIENTID_FAIL,
  LIST_PROJECT_LOCATION_REQUEST,
  LIST_PROJECT_LOCATION_SUCCESS,
  LIST_PROJECT_LOCATION_FAIL,
  RESET_LOCATION_WITH_CLIENTID,
  LIST_ADMISSION_LOCATION_WITH_CLIENTID_SUCCESS,
  CREATE_LOCATION_REQUEST,
  CREATE_LOCATION_SUCCESS,
  CREATE_LOCATION_FAIL,
  UPDATE_LOCATION_REQUEST,
  UPDATE_LOCATION_SUCCESS,
  UPDATE_LOCATION_FAIL,
  DELETE_LOCATION_REQUEST,
  DELETE_LOCATION_SUCCESS,
  DELETE_LOCATION_FAIL,
  DETAIL_LOCATION_REQUEST,
  DETAIL_LOCATION_SUCCESS,
  DETAIL_LOCATION_FAIL,
  SUMMARY_LOCATION_REQUEST,
  SUMMARY_LOCATION_SUCCESS,
  SUMMARY_LOCATION_FAIL
} from '../../constants/locations'

const initialState = {
  loading: false,
  loadingUpdate: false,
  loadingCreate: false,
  loadingDelete: false,
  loadingGetDetail: false,
  locations: [],
  location: {},
  clientLocations: [],
  admissionClientLocations: [],
  projectLocation: [],
  loadingProjectLocation: false,
  error: null,
  pageable: {
    page: 1,
    size: 10
  },
  locationSummary: []
}

const listLocationReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_LOCATION_REQUEST:
      return { ...state, loading: true }
    case LIST_LOCATION_SUCCESS:
      return { ...state, loading: false, locations: action.payload, pageable: action.pageable }
    case LIST_LOCATION_FAIL:
      return { ...state, loading: false, error: action.payload }
    case LIST_LOCATION_WITH_CLIENTID_REQUEST:
      return { ...state, loading: true, clientLocations: [] }
    case LIST_LOCATION_WITH_CLIENTID_SUCCESS:
      return { ...state, loading: false, clientLocations: action.payload }
    case LIST_ADMISSION_LOCATION_WITH_CLIENTID_SUCCESS:
      return { ...state, loading: false, admissionClientLocations: action.payload }
    case LIST_LOCATION_WITH_CLIENTID_FAIL:
      return { ...state, loading: false, error: action.payload }
    case LIST_PROJECT_LOCATION_REQUEST:
      return { ...state, loadingProjectLocation: true, projectLocation: [] }
    case LIST_PROJECT_LOCATION_SUCCESS:
      return {
        ...state,
        loadingProjectLocation: false,
        projectLocation: action.payload
      }
    case LIST_PROJECT_LOCATION_FAIL:
      return { ...state, loadingProjectLocation: false, error: action.payload }
    case RESET_LOCATION_WITH_CLIENTID:
      return { ...state, clientLocations: [], locations: [], loading: false }
    case CREATE_LOCATION_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_LOCATION_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_LOCATION_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case UPDATE_LOCATION_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_LOCATION_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_LOCATION_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_LOCATION_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_LOCATION_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_LOCATION_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case DETAIL_LOCATION_REQUEST:
      return { ...state, loadingGetDetail: true, location: {} }
    case DETAIL_LOCATION_SUCCESS:
      return { ...state, loadingGetDetail: false, location: action.payload }
    case DETAIL_LOCATION_FAIL:
      return { ...state, loadngGetDetail: false, error: action.payload }
    case SUMMARY_LOCATION_REQUEST:
      return { ...state, loading: true }
    case SUMMARY_LOCATION_SUCCESS:
      return { ...state, loading: false, locationSummary: action.payload }
    case SUMMARY_LOCATION_FAIL:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export default listLocationReducer
